/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Search, Users, ArrowRight } from "lucide-react";
import RenderSupportPage from "../RenderSupportPage";
import Loader from "../../Components/Loader";
import { dataActionCreators } from "../../services/Actions";

// Member lookup — the CRM entry point. Runs on the existing /users/members
// endpoint the admin Members page already uses, so this works today.

function MemberDirectory() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { GetMembers } = bindActionCreators(dataActionCreators, dispatch);

  const data = useSelector((state) => state.data);
  const { members, isLoading } = data;

  const [search, setSearch] = useState("");

  useEffect(() => {
    GetMembers(true, 1, 20);
  }, []);

  const runSearch = () => {
    GetMembers(true, 1, 20, search ? `&search=${search}` : null);
  };

  const rows = members || [];

  return (
    <RenderSupportPage title="Members">
      {isLoading && <Loader />}

      <p className="text-sm text-slate-500 dark:text-slate-400 -mt-4 mb-5">
        Look up a member to see their full history and open tickets.
      </p>

      <div className="flex items-center gap-2 mb-5">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-2.5 text-slate-400" />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && runSearch()}
            placeholder="Search by name or staff ID"
            className="pl-9 pr-3 py-2 text-sm border border-slate-300 dark:border-gray-600 rounded-lg w-80 bg-white dark:bg-gray-800 text-slate-700 dark:text-slate-200 focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        <button
          onClick={runSearch}
          className="px-4 py-2 text-sm font-semibold rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm"
        >
          Search
        </button>
      </div>

      {rows.length === 0 ? (
        <div className="bg-white dark:bg-gray-800 rounded-2xl border border-slate-200 dark:border-gray-700 py-16 text-center">
          <Users size={30} className="mx-auto text-slate-300 dark:text-slate-600 mb-3" />
          <p className="text-sm font-semibold text-slate-500 dark:text-slate-400">No members found</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {rows.map((m) => (
            <button
              key={m._id || m.staff_id}
              onClick={() => history.push(`/support/member-detailed?staff_id=${m.staff_id}`)}
              className="flex items-center gap-3 p-4 rounded-2xl border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:shadow-md hover:border-indigo-200 dark:hover:border-indigo-800 transition-all group text-left"
            >
              <img
                src={m?.profile_image || "/images/dev/avarta2.jpeg"}
                alt="Member"
                className="w-10 h-10 rounded-full border-2 border-white dark:border-gray-600 shadow-sm flex-shrink-0"
              />
              <div className="min-w-0 flex-1">
                <p className="text-xs font-bold text-slate-800 dark:text-slate-100 truncate">
                  {m?.name || `${m?.first_name || ""} ${m?.last_name || ""}`.trim() || "—"}
                </p>
                <p className="text-[11px] text-slate-400 dark:text-slate-500 truncate">
                  {m?.staff_id || "—"}
                </p>
              </div>
              <ArrowRight size={15} className="text-indigo-500 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
            </button>
          ))}
        </div>
      )}
    </RenderSupportPage>
  );
}

export default MemberDirectory;
